import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Bell, Send } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AdminNotificacoes() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", type: "info", target_profile: "all", target_estado: "", target_cidade: "" });
  const load = () => api.get("/admin/notifications").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form };
    if (!payload.target_profile || payload.target_profile === "all") delete payload.target_profile;
    if (!payload.target_estado) delete payload.target_estado;
    if (!payload.target_cidade) delete payload.target_cidade;
    try {
      const { data } = await api.post("/admin/notifications", payload);
      toast.success(`Notificação enviada para ${data.sent_count} usuário(s)`);
      setForm({ title: "", body: "", type: "info", target_profile: "all", target_estado: "", target_cidade: "" });
      load();
    } catch { toast.error("Erro ao enviar"); }
  };

  return (
    <AdminLayout title="Notificações">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="rounded-xl"><CardContent className="p-5">
          <h3 className="font-display font-semibold text-[hsl(var(--primary))] flex items-center gap-2"><Bell className="w-4 h-4" /> Nova notificação</h3>
          <form onSubmit={submit} className="mt-4 space-y-3">
            <div><Label>Título</Label><Input required value={form.title} onChange={(e) => setForm(f => ({ ...f, title: e.target.value }))} data-testid="notif-title" /></div>
            <div><Label>Mensagem</Label><Textarea rows={4} required value={form.body} onChange={(e) => setForm(f => ({ ...f, body: e.target.value }))} data-testid="notif-body" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Tipo</Label>
                <Select value={form.type} onValueChange={(v) => setForm(f => ({ ...f, type: v }))}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="info">Info</SelectItem>
                    <SelectItem value="success">Sucesso</SelectItem>
                    <SelectItem value="warning">Aviso</SelectItem>
                    <SelectItem value="alert">Alerta</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div><Label>Área (segmento)</Label>
                <Select value={form.target_profile} onValueChange={(v) => setForm(f => ({ ...f, target_profile: v }))}>
                  <SelectTrigger><SelectValue placeholder="Todos" /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    <SelectItem value="legislativo">Legislativo</SelectItem>
                    <SelectItem value="licitacoes">Licitações</SelectItem>
                    <SelectItem value="ambos">Ambos</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div><Label>Estado (UF)</Label><Input maxLength={2} value={form.target_estado} onChange={(e) => setForm(f => ({ ...f, target_estado: e.target.value.toUpperCase() }))} placeholder="opcional" /></div>
              <div><Label>Cidade</Label><Input value={form.target_cidade} onChange={(e) => setForm(f => ({ ...f, target_cidade: e.target.value }))} placeholder="opcional" /></div>
            </div>
            <Button type="submit" className="w-full" data-testid="admin-notification-send-button"><Send className="w-4 h-4 mr-2" /> Enviar</Button>
          </form>
        </CardContent></Card>

        <Card className="rounded-xl"><CardContent className="p-0 overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>Título</TableHead><TableHead>Tipo</TableHead><TableHead>Segmento</TableHead><TableHead>Enviadas</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map(n => (
                <TableRow key={n.id}>
                  <TableCell><p className="font-medium">{n.title}</p><p className="text-xs text-muted-foreground line-clamp-1">{n.body}</p></TableCell>
                  <TableCell><Badge variant="secondary" className="capitalize">{n.type}</Badge></TableCell>
                  <TableCell className="text-xs">
                    {n.target_profile && <span>perfil: {n.target_profile}<br /></span>}
                    {n.target_estado && <span>estado: {n.target_estado}<br /></span>}
                    {n.target_cidade && <span>cidade: {n.target_cidade}</span>}
                    {!n.target_profile && !n.target_estado && !n.target_cidade && <span>todos</span>}
                  </TableCell>
                  <TableCell>{n.sent_count}</TableCell>
                </TableRow>
              ))}
              {items.length === 0 && <TableRow><TableCell colSpan={4} className="py-10 text-center text-sm text-muted-foreground">Nenhuma notificação</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent></Card>
      </div>
    </AdminLayout>
  );
}
